<section class="sect-sponsors">
    <h2>Nuestros Sponsors</h2>
    <div class="sponsors-cont">
        <div class="img-cont">

            <img src="./assets/sponsor1.png" alt="logo de triunfo seguro">
        </div>
        <div class="img-cont">

            <img src="./assets/sponsor2.png" alt="logo de electrinet">
        </div>
       <!--  <div class="img-cont">
            <img src="./assets/sponsor3.png" alt="logo de camara ph">

        </div> -->
        <div class="img-cont">

            <img src="./assets/sponsor4.png" alt="logo de mellano seguridad">
        </div>
    </div>
</section>